import { render, staticRenderFns } from "./CreditorAgeing.vue?vue&type=template&id=5ebf15d8&scoped=true&"
import script from "./CreditorAgeing.vue?vue&type=script&lang=js&"
export * from "./CreditorAgeing.vue?vue&type=script&lang=js&"
import style0 from "./CreditorAgeing.vue?vue&type=style&index=0&id=5ebf15d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebf15d8",
  null
  
)

export default component.exports